<template>
  <v-content class="pa-12">
    <v-layout justify-space-around>
      <v-flex
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>ผู้เข้าร่วมการประชุม</span>
      </v-flex>
    </v-layout>
    <v-layout mt-6>
      <v-flex shrink d-flex align-center style="color: black;font-size: 18px;">
        <span><b>วันที่การประชุม</b></span>
      </v-flex>
      <v-flex xs3 shrink mx-2 d-flex align-center justify-start>
        <text-autocomplete
          placeholder="วันที่การประชุม"
          :items="meetingList"
          item-text="name"
          itemValue="id"
          :model="meeting"
          hide-details
          @update-data="updateData('meeting', $event)"
        />
      </v-flex>
      <!--<v-flex shrink v-if="meeting" mx-2>-->
        <!--<text-autocomplete-->
          <!--placeholder="สถานะการเข้ารวประชุม"-->
          <!--:items="meetingStatusList"-->
          <!--item-text="status"-->
          <!--itemValue="id"-->
          <!--:model="meetingStatus"-->
          <!--hide-details-->
          <!--@update-data="updateData('meetingStatus', $event)"-->
        <!--/>-->
      <!--</v-flex>-->
      <v-flex shrink v-if="meeting" mx-2 d-flex align-center justify-start>
        <v-text-field
          clearable
          @click:clear="onClearable"
          placeholder="ชื่อคณะอนุกรรมการ"
          color="#3e7662"
          dense
          outlined
          v-model="name"
          hide-details
        />
      </v-flex>
      <v-flex
        shrink
        mx-2
        d-flex
        align-center
        style="color: black;font-size: 18px;"
      >
        <v-btn
          dark
          style="background-color: rgb(84, 74, 68);"
          @click="getMeetingAttendees(1)"
        >
          <span>ค้นหา</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <!-- <v-layout v-if="meeting" mt-2>
      <v-flex xs2 d-flex align-center style="color: black;font-size: 18px;">
        <span><b>ชื่ออนุกรรมการ</b></span>
      </v-flex>
      <v-flex xs4 mr-4 d-flex align-center justify-start>
        <v-text-field
          clearable
          @click:clear="onClearable"
          placeholder="ชื่อคณะอนุกรรมการ"
          color="#3e7662"
          dense
          outlined
          v-model="name"
          hide-details
        />
      </v-flex>
      <v-flex
        shrink
        mr-4
        d-flex
        align-center
        style="color: black;font-size: 18px;"
      >
        <v-btn
          color="#3e7662"
          dark
          @click="getSearchMeetingAttendeesPaginate(1)"
        >
          <span class="font-weight-bold">ค้นหา</span>
        </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout> -->
    <!-- Table -->
    <v-layout mt-8>
      <v-flex>
        <form-table :headers="headers" :items="MeetingAttendees"></form-table>
      </v-flex>
    </v-layout>
    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination
          color="#3E7662"
          :length="paginate.last_page"
          :total-visible="9"
          @input="getMeetingAttendees"
          v-model="paginate.current_page"
        ></v-pagination>
      </v-flex>
    </v-layout>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
  </v-content>
</template>

<script>
import FormTable from "../../components/table/FormTable";
import Loading from "vue-loading-overlay";
import "vue-select/dist/vue-select.css";
import { mapState, mapActions } from "vuex";
import TextAutocomplete from "../../components/input/TextAutocomplete";

export default {
  name: "MeetingAttendees",
  components: {
    FormTable,
    Loading,
    TextAutocomplete,
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    meetingList: [],
    meetingStatusList: [
      { id: 1, status: "เข้าร่วม" },
      { id: 2, status: "ไม่เข้าร่วม" },
      { id: 3, status: "ไม่ทราบ" },
    ],
    meeting: "",
    meetingStatus: "",
    menu: false,
    isLoading: false,
    fullPage: true,
    paginate: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    paginateSearchMeetingAttendees: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    headers: [
      { text: "ลำดับ", value: "number", align: "center", width: "10%" },
      {
        text: "รายชื่อคณะอนุกรรมการ",
        value: "name",
        align: "center",
        width: "60%",
      },
      {
        text: "สถานะการเข้ารวประชุม",
        value: "status",
        align: "center",
        width: "30%",
      },
    ],
    MeetingAttendees: [],
    name: "",
  }),
  created() {
    this.getMeetingList(1);
  },
  methods: {
    getMeetingList() {
      this.$store.dispatch("Meeting/getMeetList").then((res) => {
        res.forEach((data) => {
          this.meetingList.push({
            id: data.id,
            name: data.meetingName + " (" + data.meetingDate + ")",
          });
        });
      });
    },
    findMatching(a, b) {
      return a == b;
    },
    getMeetingAttendees(page) {
      this.MeetingAttendees = [];
      this.$store
        .dispatch("Meeting/getMeetingAttendees", {
          page: page,
          meetingID: this.meeting,
          name: this.name,
          meetingStatus: this.meetingStatus,
        })
        .then((res) => {
          console.log(res);
          let i = 1;
          res.data.forEach((data) => {
            this.MeetingAttendees.push({
              number: i,
              name: data.user ? data.user.thName : "-",
              status: this.checkStatus(data.isJoin),
            });
            i++;
          });
          this.paginate.current_page = res.current_page;
          this.paginate.from = res.from;
          this.paginate.last_page = res.last_page;
          this.paginate.per_page = res.per_page;
          this.paginate.total = res.total;
          this.paginate.to = res.to;
        });
    },
    // getAllMeetingAttendeesPaginate(page) {
    //   this.MeetingAttendees = [];
    //   this.$store
    //     .dispatch("Meeting/getAllMeetingAttendees", {
    //       page: page,
    //       meetingID: this.meeting,
    //     })
    //     .then((res) => {
    //       let i = 1;
    //       res.data.forEach((data) => {
    //         this.MeetingAttendees.push({
    //           number: i,
    //           name: data.thName,
    //           status: this.checkStatus(data.isJoin),
    //         });
    //         i++;
    //       });
    //       this.paginate.current_page = res.current_page;
    //       this.paginate.from = res.from;
    //       this.paginate.last_page = res.last_page;
    //       this.paginate.per_page = res.per_page;
    //       this.paginate.total = res.total;
    //       this.paginate.to = res.to;
    //     });
    // },
    // getSearchMeetingAttendeesPaginate(page) {
    //   this.MeetingAttendees = [];
    //   this.$store
    //     .dispatch("Meeting/getSearchMeetingAttendees", {
    //       page: page,
    //       meetingID: this.meeting,
    //       name: this.name,
    //     })
    //     .then((res) => {
    //       let i = 1;
    //       res.data.forEach((data) => {
    //         this.MeetingAttendees.push({
    //           number: i,
    //           name: data.thName,
    //           status: this.checkStatus(data.isJoin),
    //         });
    //         i++;
    //       });
    //       this.paginate.current_page = res.current_page;
    //       this.paginate.from = res.from;
    //       this.paginate.last_page = res.last_page;
    //       this.paginate.per_page = res.per_page;
    //       this.paginate.total = res.total;
    //       this.paginate.to = res.to;
    //     });
    // },
    checkStatus(id) {
      switch (id) {
        case 0:
          return "ไม่เข้าร่วม";
        case 1:
          return "เข้าร่วม";
        case 2:
          return "ไม่ทราบ";
      }
    },
    updateData(text, val) {
      this[text] = val;
    },
    onClearable() {
      this.name = "";
      this.getMeetingAttendees(1);
    },
  },
};
</script>

<style lang="scss">
// V-select
.style-chooser .vs__search::placeholder,
    .style-chooser .vs__dropdown-toggle,
    .style-chooser .vs__selected
        /*.style-chooser .vs__dropdown-menu:hover*/
 {
  background: #3e7662;
  border: solid 2px #3e7662;
  color: #fff;
  /*text-transform: lowercase;*/
  /*font-variant: small-caps;*/
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #fff;
}
</style>
